import React from 'react'
import errorIcon from 'assets/icons/error.svg'
const OImage = ({ src, fallbackUrl, ...rest }) => {
  return (
    <>
      <img
        src={src}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null
          currentTarget.src = fallbackUrl ?? errorIcon
        }}
        {...rest}
        // alt=''
        alt='property'
        width='500'
        height='600'
      />
    </>
  )
}

export default OImage
